<template>
  <p
    class="p"
    :class="[
      color ? 'p--color-' + color : '',
      {
        'p--small': small,
        'p--medium': medium,
        'p--large': large,
        'p--lxl': lxl,
        'p--align-center': alignCenter,
        'p--align-right': alignRight,
      },
    ]"
  >
    <slot />
  </p>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
    },
    medium: {
      type: Boolean,
    },
    large: {
      type: Boolean,
    },
    lxl: {
      type: Boolean,
    },
    alignRight: {
      type: Boolean,
    },
    alignCenter: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.p {
  font-size: map-get($font-sizes-paragraph, 'm');

  @include bp(m) {
    font-size: map-get($font-sizes-paragraph, 'l');
  }

  &.p--small {
    font-size: map-get($font-sizes, 's');
  }

  &.p--medium {
    font-size: map-get($font-sizes, 'm');
  }

  &.p--large {
    font-size: map-get($font-sizes, 'l');
  }

  &.p--lxl {
    font-size: map-get($font-sizes, 'lxl');
  }

  &.p--align-right {
    text-align: right;
  }

  &.p--align-center {
    text-align: center;
  }

  // Colors
  @each $palette, $tones in $palettes {
    @each $tone, $hex in $tones {
      @if $tone == 'base' {
        &.p--color-#{$palette} {
          color: $hex;
        }
      } @else {
        &.p--color-#{$palette}-#{$tone} {
          color: $hex;
        }
      }
    }
  }
}
</style>
